/**
 * @author Hiroki Moto
 */

import React, { memo } from 'react';
import EditDropdown from '@components/EditDropdown';
import PremiumShow from '../Products/PremiumShow';
import Recent from '../Products/Recent';
import Others from '../Products/Others';

const Premium = ({ title, data, company, businessId, isAdmin, onEdit, onDetail, products, logo }) => {
    const others = products?.filter((p) => p.id !== data?.id && (p.data?.sponsored_level === 'gold' || p.data?.sponsored_level === 'silver'));
    return (
        <>
            <div className="card position-relative">
                <PremiumShow title={title} data={data} onDetail={onDetail} />
                {isAdmin && <EditDropdown className="edit-all" options={['Edit', 'Reports']} onChange={onEdit(data)} />}
            </div>
            <div className="d-flex mt-3 flex-md-row flex-column">
                <div className="d-flex-2 me-md-2">
                    <div className="card">
                        <Recent data={data} company={company} businessId={businessId} />
                    </div>
                </div>
                <div className="other-products d-flex-1 ms-md-2">
                    <div className="card">
                        <Others data={others} onDetail={onDetail} logo={logo} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default memo(Premium);
